module.exports = __webpack_public_path__ + "static/img/transcoding.f7adc1e2.gif";